// Logs only in `vite dev`. A production build replaces DEV with false and prints nothing.
export const debugLog = (...args: unknown[]): void => {
  // eslint-disable-next-line no-restricted-syntax
  if (import.meta.env.DEV) console.log(...args)
}
